
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/restaurants/quick-service-restaurants-pos-billing-software",
      function () {
        return require("private-next-pages/restaurants/quick-service-restaurants-pos-billing-software.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/restaurants/quick-service-restaurants-pos-billing-software"])
      });
    }
  